import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import PropTypes from "prop-types";
import "./FilterSortBarLoader.scss";

const ButtonLoader = ({ width = 100 }) => {
	return (
		<div className="button-loader">
			<LoaderBar height={12} width={width} />
		</div>
	);
};

ButtonLoader.propTypes = {
	width: PropTypes.number,
};

export const FilterSortBarLoader = () => {
	return (
		<div className="filter-sort-bar-loader">
			<ButtonLoader width={160} />
			<ButtonLoader width={70} />
			<ButtonLoader width={80} />
			<ButtonLoader width={110} />
			<ButtonLoader width={140} />
			<ButtonLoader width={70} />
			<ButtonLoader width={80} />
		</div>
	);
};
